import { createFileRoute } from "@tanstack/react-router";

import { AuthShell } from "@features/auth/AuthShell";
import { requireSignedOut } from "@features/auth/route-guards";

export const Route = createFileRoute("/register")({
  beforeLoad: requireSignedOut,
  component: RegisterPage,
});

function RegisterPage() {
  return (
    <AuthShell.Root mode="register">
      <AuthShell.Wordmark />
      <AuthShell.Tagline />
      <AuthShell.SocialRow providers={["google", "twitter", "discord", "github"]} />
      <AuthShell.Divider />
      <AuthShell.EmailForm />
      <AuthShell.Footer />
    </AuthShell.Root>
  );
}
